import apiClient from '@/utils/api-client'

class PlisioService {
    public getPaymentUrl(planId: string) {
        return new Promise<string>((resolve, reject) => {
            apiClient.get('/api/v1/plisio/payment-url/' + planId).then((res) => {
                if (res.status == 200 && res.data != null) {
                    if (res.data.status == 6022) {
                        resolve(res.data.url)
                    } else {
                        resolve("false")
                    }
                } else {
                    resolve("false")
                }
            }).catch((error) => {
                reject(error)
            })
        })
    }
}

export default new PlisioService()
